import React, { Fragment } from "react";
import Navbar from "../components/Navbar/Navbar";
import { accountingMenu } from "../data/accountingMenu";


const AccountLayout = ({ children }) => {
  return (
    <Fragment>
      {/* <HeaderUrl /> */}
      <Navbar menuList={accountingMenu} />
      {children}
    </Fragment>
  );
};

export default AccountLayout;
